/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../notification/message/message.component.ngfactory';
import * as import2 from '../../notification/message/message.component';
import * as import3 from '../../notification/notification.service';
import * as import4 from '@angular/common';
import * as import5 from './order-errors-panel.component';
import * as import6 from '../order.model';
import * as import7 from '../../ordering-context/ordering-context.model';
import * as import8 from '../../orchestration/session.model';
const styles_OrderErrorsPanelComponent:any[] = ([] as any[]);
export const RenderType_OrderErrorsPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_OrderErrorsPanelComponent,
  data: {}
}
);
function View_OrderErrorsPanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-footer-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'onClose'
      ]
      ,
      [
        (null as any),
        'click'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('onClose' === en)) {
        const pd_1:any = ((<any>(co.orderModel.orderErrorStates.orderWithInvalidTimeAttempted = false)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import1.View_FooterMessageComponent_0,import1.RenderType_FooterMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import2.FooterMessageComponent,[
      import0.ElementRef,
      import3.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]
      ,
      translationParams: [
        2,
        'translationParams'
      ]
      ,
      closable: [
        3,
        'closable'
      ]

    }
    ,{onClose: 'onClose'}),
    import0.ɵqud(603979776,1,{links: 1}),
    import0.ɵpod(['storeName'])
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.ERROR;
    const currVal_9:any = co.orderModel.invalidOrderTimeMessage;
    const currVal_10:any = ck(v,3,0,((co.orderingContextModel.currentStore == null)? (null as any): co.orderingContextModel.currentStore.name));
    const currVal_11:any = true;
    ck(v,1,0,currVal_8,currVal_9,currVal_10,currVal_11);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_OrderErrorsPanelComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-footer-message',([] as any[]),[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'onClose'
      ]
      ,
      [
        (null as any),
        'click'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('onClose' === en)) {
        const pd_1:any = ((<any>(co.orderModel.orderErrorStates.tableOrderWithTimeAttempted = false)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import1.View_FooterMessageComponent_0,import1.RenderType_FooterMessageComponent)),
    import0.ɵdid(5488640,(null as any),1,import2.FooterMessageComponent,[
      import0.ElementRef,
      import3.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]
      ,
      closable: [
        2,
        'closable'
      ]

    }
    ,{onClose: 'onClose'}),
    import0.ɵqud(603979776,2,{links: 1})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.ERROR;
    const currVal_9:any = 'woa.message.order.tableOrderTimeUnused';
    const currVal_10:any = true;
    ck(v,1,0,currVal_8,currVal_9,currVal_10);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
export function View_OrderErrorsPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderErrorsPanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderErrorsPanelComponent_2)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import5.OrderErrorsPanelComponent = v.component;
    const currVal_0:any = co.orderModel.orderErrorStates.orderWithInvalidTimeAttempted;
    ck(v,1,0,currVal_0);
    const currVal_1:any = co.orderModel.orderErrorStates.tableOrderWithTimeAttempted;
    ck(v,4,0,currVal_1);
  },(null as any));
}
function View_OrderErrorsPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-errors-panel',([] as any[]),(null as any),(null as any),(null as any),View_OrderErrorsPanelComponent_0,RenderType_OrderErrorsPanelComponent)),
    import0.ɵdid(245760,(null as any),0,import5.OrderErrorsPanelComponent,[
      import6.OrderModel,
      import7.OrderingContextModel,
      import8.SessionModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const OrderErrorsPanelComponentNgFactory:import0.ComponentFactory<import5.OrderErrorsPanelComponent> = import0.ɵccf('woa-order-errors-panel',import5.OrderErrorsPanelComponent,View_OrderErrorsPanelComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/order/order-errors-panel/order-errors-panel.component.ngfactory.ts